import {createSlice} from '@reduxjs/toolkit';
import {getDeprecatedAccessModulesFailure, getDeprecatedAccessModulesSuccess} from 'src/openapi/admin/apis/LicenseAccessModulesApi';

import type {DeprecatedAccessModule} from 'src/openapi/admin/models/DeprecatedAccessModule';
import type {AppState} from 'src/store/typedef';

export const initialState: {
    list: Array<DeprecatedAccessModule> | null,
    map: Record<string, string> | null,
} = {
    list: null,
    map: null,
};

export const deprecatedAccessModulesSlice = createSlice({
    name: 'deprecatedAccessModules',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(getDeprecatedAccessModulesSuccess, (state, action) => {
                state.list = [...action.payload.data];
                state.map = action.payload.data.reduce((acc, item) => {
                    acc[item.moduleCode] = item.description;
                    return acc;
                }, {} as Record<string, string>);
            })
            .addCase(getDeprecatedAccessModulesFailure, state => {
                state.list = [];
                state.map = {};
            });
    },
});

export const selectDeprecatedAccessModules: (state: AppState) => Array<DeprecatedAccessModule> | null = state => {
    return state.deprecatedAccessModules.list;
};

export const selectDeprecatedAccessModulesMap: (state: AppState) => Record<string, string> | null = state => {
    return state.deprecatedAccessModules.map;
};
